import type { WorkspaceRuntime } from './runtime';
export type Entity = { id: string; [key: string]: any };
export type Data = {
  runtime?: WorkspaceRuntime;
  contacts: Entity[];
  accounts: Entity[];
  leads: Entity[];
  offers: Entity[];
  properties: Entity[];
  opportunities: Entity[];
  tasks: Entity[];
  visits: Entity[];
  campaigns: Entity[];
  interactions: Entity[];
  workflows: Entity[];
  suppliers: Entity[];
  audit: Entity[];
  settings: any;
  user: any;
  integrations: any;
  [key: string]: any;
};
export type Page =
  | 'overview'
  | 'contacts'
  | 'accounts'
  | 'leads'
  | 'pipeline'
  | 'properties'
  | 'matches'
  | 'visits'
  | 'tasks'
  | 'team'
  | 'campaigns'
  | 'communications'
  | 'automations'
  | 'analytics'
  | 'website-tracking'
  | 'suppliers'
  | 'data-input'
  | 'prospect-discovery'
  | 'prospect-pool'
  | 'targeting-audiences'
  | 'ad-strategy'
  | 'funnel-performance'
  | 'settings';
export const stages = [
  'New',
  'Validated',
  'Engaged',
  'Qualified',
  'Advisor Engaged',
  'Site Visit',
  'Negotiation',
  'Nurture',
  'Disqualified',
  'Closed Won',
  'Closed Lost',
];
export const emptyData: Data = {
  contacts: [],
  accounts: [],
  leads: [],
  offers: [],
  properties: [],
  opportunities: [],
  tasks: [],
  visits: [],
  campaigns: [],
  interactions: [],
  workflows: [],
  suppliers: [],
  audit: [],
  settings: {},
  user: { name: '', role: '' },
  integrations: [],
};
